/* eslint-disable react/no-danger */
import React from 'react';

import Blocks from '../blocks/Blocks';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/pages/normal.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

const defaultProps = {};

const NormalPage = ({ page }) => {
    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <div className={styles.content}>
                    <Blocks blocks={page.blocks} />
                </div>
            </div>
        </div>
    );
};
NormalPage.propTypes = propTypes;
NormalPage.defaultProps = defaultProps;

export default NormalPage;
